
      import '../src/record-player';
      import '@folkjs/labs/standalone/folk-shape';
      import { proximal } from '@folkjs/geometry/Rect2D';

      let proximityDistance = 100;
      const proximitySet = new Set();
      const recordPlayerGeometry = document.querySelector('folk-shape:has(record-player)');
      const recordPlayer = recordPlayerGeometry.firstElementChild;
      const flowers = document.querySelectorAll('folk-shape:has(video)');
      // set playback rate when video is ready
      function setPlayback(e) {
        e.target.playbackRate = (91 / 60) * e.target.duration;
        e.target.removeEventListener('canplay', setPlayback);
      }

      flowers.forEach((el) => {
        el.firstElementChild.addEventListener('canplay', setPlayback);
      });

      function updateFlowerProximity(flower) {
        const alreadyIntersection = proximitySet.has(flower);

        const isNowIntersecting = proximal(
          recordPlayerGeometry.getTransformDOMRect(),
          flower.getTransformDOMRect(),
          proximityDistance,
        );

        const video = flower.firstElementChild;
        if (isNowIntersecting && !alreadyIntersection) {
          proximitySet.add(flower);
          if (!recordPlayer.paused) {
            video.play();
          }
        } else if (alreadyIntersection && !isNowIntersecting) {
          proximitySet.delete(flower);
          video.pause();
        }
      }

      function updateRecordPlayerProximity() {
        proximitySet.forEach((el) => el.firstElementChild.pause?.());
        proximitySet.clear();

        for (const flower of flowers) {
          updateFlowerProximity(flower);
        }
      }

      function handleProximity(e) {
        if (e.target === recordPlayerGeometry) {
          updateRecordPlayerProximity();
        } else {
          updateFlowerProximity(e.target);
        }
      }

      document.addEventListener('transform', handleProximity);

      document.addEventListener('playing', (e) => {
        proximitySet.forEach((el) => el.firstElementChild.play?.());
      });

      document.addEventListener('stopped', (e) => {
        proximitySet.forEach((el) => {
          el.firstElementChild.pause?.();
          el.firstElementChild.currentTime = 0;
        });
      });

      function updateVolume() {
        proximityDistance = recordPlayer.volume * 500;
        updateRecordPlayerProximity();
      }

      updateVolume();

      document.addEventListener('volume', updateVolume);
    